import { REPORT_ADDRESSES_API } from 'constants/AppConstants';

// #genai Name the default export without changing its signature or callers.
export default async function getReportAddresses(orderId, signature) {
  try {
    const queryParams = new URLSearchParams({ orderId: String(orderId) });
    if (signature) {
      queryParams.set('signature', signature);
    }
    const response = await fetch(`${REPORT_ADDRESSES_API}?${queryParams.toString()}`, { skipAuthHeader: true });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
}
